import type { Id } from "@repo/convex/dataModel";
import { useMemo } from "react";
import { resolveTreeNodeCreateActions } from "../lib/create-actions";
import type { TreeItem } from "../types";
import { useProjectFrameworkStructure } from "./useProjectData";

export function useTreeNodeCreateActions(projectId: Id<"projects"> | null, item: TreeItem) {
  const structure = useProjectFrameworkStructure(projectId);

  return useMemo(
    () =>
      resolveTreeNodeCreateActions({
        structure: structure ?? null,
        item,
      }),
    [item, structure]
  );
}
